var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputSuccess = function SvgInputSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#inputSuccess_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43B65C",
    d: "M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m4.618 5.467-4.563 6.192a.674.674 0 0 1-.954.126L3.843 9.179a.667.667 0 1 1 .833-1.041l2.717 2.174 4.152-5.634a.666.666 0 1 1 1.073.789"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inputSuccess_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgInputSuccess;